import { render, staticRenderFns } from "./ModalFollowupWebCheckin.vue?vue&type=template&id=a64c1ac2&scoped=true&"
import script from "./ModalFollowupWebCheckin.vue?vue&type=script&lang=js&"
export * from "./ModalFollowupWebCheckin.vue?vue&type=script&lang=js&"
import style0 from "./ModalFollowupWebCheckin.vue?vue&type=style&index=0&id=a64c1ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c1ac2",
  null
  
)

export default component.exports